import React from 'react';
interface IProfileContentProps {
  curUser: any;
}

const ProfileContent: React.FC<IProfileContentProps> = ({ curUser }) => {
  return (
    <div className='profile-content'>
      <div className='profile-basics'>
        <div className='profile-section-card'>
          <div className='profile-card-inner'>
            <div className='profile-card-primary'>
              Full Name
            </div>
            <div className='profile-card-secondary'>
              {curUser?.basics?.firstName ? curUser?.basics?.firstName : ''} {curUser?.basics?.lastName ? curUser?.basics?.lastName : ''}
            </div>
          </div>
        </div>
        <div className='profile-section-card'>
          <div className='profile-card-inner'>
            <div className='profile-card-primary'>
              Email
            </div>
            <div className='profile-card-secondary'>
              {curUser?.basics?.email ? curUser?.basics?.email : ''}
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: '10px' }} className='additional-licenses-text'>
        If you would like to change any of the info above, please contact info@bitedata.io with a request.
      </div>
    </div>
  );
};

export default ProfileContent;
